// frontend/src/pages/Reinsurance/Reinsurance.js

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { ContractProvider } from './contexts/ContractContext';
import { CedentProvider } from './contexts/CedentContext';
import Dashboard from './components/Dashboard';
import ContractManagement from './components/ContractManagement';
import ClaimManagement from './components/ClaimManagement';
import CapitalManagement from './components/CapitalManagement';
import RiskModeling from './components/RiskModeling';
import CedentManagement from './components/CedentManagement';
import InvestorManagement from './components/InvestorManagement';
import Reporting from './components/Reporting';
import styles from './Reinsurance.module.css';

const Reinsurance = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('dashboard');

  // Set active section based on URL path
  useEffect(() => {
    const path = location.pathname;
    
    if (path === '/reinsurance') {
      setActiveSection('dashboard');
    } else if (path.includes('/reinsurance/contracts')) {
      setActiveSection('contracts');
    } else if (path.includes('/reinsurance/claims')) {
      setActiveSection('claims');
    } else if (path.includes('/reinsurance/capital')) {
      setActiveSection('capital');
    } else if (path.includes('/reinsurance/risk-modeling')) {
      setActiveSection('risk-modeling');
    } else if (path.includes('/reinsurance/cedents')) {
      setActiveSection('cedents');
    } else if (path.includes('/reinsurance/investors')) {
      setActiveSection('investors');
    } else if (path.includes('/reinsurance/reporting')) {
      setActiveSection('reporting');
    }
  }, [location.pathname]);

  // Handle navigation between sections
  const handleNavigation = (section) => {
    setActiveSection(section);
    
    // Navigate to the appropriate route
    switch (section) {
      case 'dashboard':
        navigate('/reinsurance');
        break;
      case 'contracts':
        navigate('/reinsurance/contracts');
        break;
      case 'claims':
        navigate('/reinsurance/claims');
        break;
      case 'capital':
        navigate('/reinsurance/capital');
        break;
      case 'risk-modeling':
        navigate('/reinsurance/risk-modeling');
        break;
      case 'cedents':
        navigate('/reinsurance/cedents');
        break;
      case 'investors':
        navigate('/reinsurance/investors');
        break;
      case 'reporting':
        navigate('/reinsurance/reporting');
        break;
      default:
        navigate('/reinsurance');
    }
  };

  // Render the active section
  const renderActiveSection = () => {
    switch (activeSection) {
      case 'dashboard':
        return <Dashboard onNavigate={handleNavigation} />;
      case 'contracts':
        return (
          <ContractProvider>
            <CedentProvider>
              <ContractManagement />
            </CedentProvider>
          </ContractProvider>
        );
      case 'claims':
        return <ClaimManagement />;
      case 'capital':
        return <CapitalManagement />;
      case 'risk-modeling':
        return <RiskModeling />;
      case 'cedents':
        return <CedentManagement />;
      case 'investors':
        return <InvestorManagement />;
      case 'reporting':
        return <Reporting />;
      default:
        return <Dashboard onNavigate={handleNavigation} />;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.sectionContent}>
        {renderActiveSection()}
      </div>
    </div>
  );
};

export default Reinsurance;